import React from 'react'
import { Container, TextBody, Link, Icon } from '@pdrj/pmi-iqos-ds-react'
import HeaderNotice from './header-notice.js'
import { goToRoute, getRoute, Routes, Sites } from '@pdrj/pmi-iqos-shared-react'

class NoticeTemplateHelper {}

NoticeTemplateHelper.getNoticeDisplay = ({
  template,
  data,
  date,
  read,
  handleNotice,
  id,
  regState
}) => {
  if (!data || !date) return null

  const expiredDate = data.expired_at?.replace(/ /g, 'T')
  const expiredDateParsed = new Date(expiredDate)
  const newDate = new Date()

  return noticeTemplateIds[template]
    ? noticeTemplateIds[template]({
        data,
        expiredDate,
        expiredDateParsed,
        newDate,
        date,
        read,
        handleNotice,
        id,
        regState
      })
    : null
}

const noticeLinkHandler = async (e, handleNotice, id, url) => {
  e.preventDefault()
  e.stopPropagation()
  await handleNotice(id)
  goToRoute({
    mainPath: url
  })
}

const getEmailVerificationRoute = () => {
  return getRoute(Routes.conversion, true, false, null, null, Sites.iqos)
}

const getProfileDevicesRoute = () => {
  return getRoute(Routes.profileDevices, true, false, null, null, Sites.iqos)
}

const getPromotionRoute = () => {
  return getRoute('/promotion', true, false, null, null, Sites.iqos)
}

const getCatalogueRoute = () => {
  return getRoute(
    '/shop/catalogue/iluma/devices',
    true,
    false,
    null,
    null,
    Sites.iqos
  )
}

const noticeCommentTemplate = ({ data, date }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
    </>
  )
}

const noticeUriTemplate = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={data.uri}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, data.uri)
            }}>
            詳しくはこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const noticeUriTemplateTwo = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={data.uri}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, data.uri)
            }}>
            {data.button}
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const noticeUriTemplateDuo = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
      <Container pt="4">
        {data['uri/web'] && (
          <TextBody>
            <Link
              newTab={false}
              href={data['uri/web']}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, data['uri/web'])
              }}>
              {data.button}
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const regstateStatusZero = ({ data, date, handleNotice, id, regState }) => {
  if (regState === undefined && regState !== 0) return null

  return (
    regState !== 4 && (
      <>
        <HeaderNotice
          date={date}
          name={'会員特典プログラムの特典製品登録が必要です'}
        />
        <TextBody
          value="会員特典プログラムの様々な特典を受けるためには、アカウント認証が必要です"
          size={TextBody.sizes.s}
        />
        <Container pt="4">
          <TextBody>
            <Link
              newTab={false}
              href={getEmailVerificationRoute()}
              onClickHandler={e => {
                noticeLinkHandler(
                  e,
                  handleNotice,
                  id,
                  getEmailVerificationRoute()
                )
              }}>
              アカウント認証はこちらからら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        </Container>
      </>
    )
  )
}

const prizeWinning = ({
  data,
  expiredDateParsed,
  newDate,
  date,
  read,
  handleNotice,
  id,
  regState
}) => {
  if (regState === undefined && regState !== 0) return null
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice date={date} name={data.title} />

      {read === false && expiredDateParsed >= newDate && (
        <>
          <TextBody
            acceptsHtml
            value={
              (regState !== 4 &&
                data.type === 1 &&
                '当選賞品のお受け取りには、当選日より3日以内にアカウントの認証と、すでに登録されている方も再度登録住所の確認が必要です。アカウント認証がまだの方はアカウント認証を完了のうえ、登録住所も再度ご確認ください。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。') ||
              (regState === 4 &&
                data.type === 1 &&
                '当選賞品のお受け取りには当選日より3日以内に登録住所の確認が必要です。すでに登録されている方も再確認が必要です。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。') ||
              (regState !== 4 &&
                data.type === 2 &&
                '交換賞品のお受け取りには、交換申し込み日より3日以内にアカウントの認証と、すでに登録されている方も再度登録住所の確認が必要です。アカウント認証がまだの方はアカウント認証を完了のうえ、登録住所も再度ご確認ください。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。') ||
              (regState === 4 &&
                data.type === 2 &&
                '交換賞品のお受け取りには交換申し込み日より3日以内に登録住所の確認が必要です。すでに登録されている方も再確認が必要です。詳しくは<a href="/rule/" class="q-link  rst-intl">利用規約</a>をご覧ください。')
            }
            size={TextBody.sizes.s}
          />
          <Container pt="4">
            {regState !== 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={getEmailVerificationRoute()}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      getEmailVerificationRoute()
                    )
                  }}>
                  アカウント認証はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}

            {regState === 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={`/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      `/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`
                    )
                  }}>
                  登録住所を確認する
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
          </Container>
        </>
      )}

      {read === false && expiredDateParsed < newDate && (
        <>
          <TextBody
            acceptsHtml
            value={
              (regState === 4 &&
                '交換申し込み日または当選日から3日が経過しました。賞品のお受け取りに必要となる住所の登録、または登録済み住所の再確認を完了していないため、交換および当選が無効となりました。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。') ||
              (regState !== 4 &&
                '交換申し込み日または当選日から3日が経過しました。賞品のお受け取りに必要となる、アカウントの認証と登録住所の確認を完了していないため、交換および当選が無効となりました。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。')
            }
            size={TextBody.sizes.s}
          />
        </>
      )}

      {read === true && (
        <>
          <TextBody
            acceptsHtml
            value={
              (data.type === 1 &&
                '登録住所のご確認ありがとうございました。賞品のお受け取りまで今しばらくお待ちください。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。') ||
              (data.type !== 1 &&
                '登録住所のご確認ありがとうございました。賞品のお受け取りまで今しばらくお待ちください。詳しくは<a href="/rule/" class="q-link rst-intl">利用規約</a>をご覧ください。')
            }
            size={TextBody.sizes.s}
          />
        </>
      )}
    </>
  )
}

const prizeWinningDigital = ({ data, date, read, handleNotice, id }) => {
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={'プレゼント：EJOICAセレクトギフトのご利用に関して'}
      />

      {read === false && (
        <>
          <TextBody
            value={
              (data.type === 1 && 'EJOICAセレクトギフトIDが発行されました。') ||
              (data.type === 2 && 'EJOICAセレクトギフトIDが発行されました。')
            }
            size={TextBody.sizes.s}
          />
          <Container pt="4">
            <TextBody>
              <Link
                newTab={false}
                href="/"
                onClickHandler={e => {
                  noticeLinkHandler(e, handleNotice, id, '/')
                }}>
                ギフトID取得はこちらから
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          </Container>
        </>
      )}
      {read === true && (
        <TextBody
          value={`${data.name}'が当選しました。'`}
          size={TextBody.sizes.s}
        />
      )}
    </>
  )
}

const prizeToropicalWinning = ({
  data,
  expiredDateParsed,
  newDate,
  date,
  read,
  handleNotice,
  id,
  regState
}) => {
  if (regState === undefined && regState !== 0) return null
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice date={date} name={data.title} />

      {read === false && expiredDateParsed >= newDate && (
        <>
          <TextBody
            value={
              (regState !== 4 &&
                data.type === 1 &&
                '当選賞品の配送にはアカウントの認証と住所登録が必要です。アカウントの認証を済ませてから、住所登録へと進んでください') ||
              (regState === 4 && data.type === 1 && `${data.comment}`) ||
              (regState !== 4 &&
                data.type === 2 &&
                '交換賞品の配送にはアカウントの認証と住所登録が必要です。アカウントの認証を済ませてから、住所登録へと進んでください') ||
              (regState === 4 && data.type === 2 && `${data.comment}`)
            }
            size={TextBody.sizes.s}
          />
          <Container pt="4">
            {regState !== 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={getEmailVerificationRoute()}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      getEmailVerificationRoute()
                    )
                  }}>
                  アカウント認証はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
            {regState === 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={`/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      `/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`
                    )
                  }}>
                  住所登録はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
          </Container>
        </>
      )}

      {read === false && expiredDateParsed < newDate && (
        <>
          <TextBody size={TextBody.sizes.s}>
            {regState !== 4 && 'アカウントの認証・住所登録期限が終了しました'}
            {regState === 4 && '住所登録期限が終了しました<'}
          </TextBody>
        </>
      )}

      {read === true && (
        <TextBody
          value={`${data.name}'が当選しました。'`}
          size={TextBody.sizes.s}
        />
      )}
    </>
  )
}

const prizeWinningCherish = ({
  data,
  expiredDateParsed,
  newDate,
  date,
  handleNotice,
  id,
  regState
}) => {
  if (regState === undefined && regState !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={'体験クーポンをご利用いただけなかったお客様へ'}
      />
      {expiredDateParsed >= newDate && (
        <>
          <TextBody
            value={
              (regState !== 4 &&
                '当選賞品の配送にはアカウントの認証と住所登録が必要です。アカウントの認証を済ませてから、住所登録へと進んでください') ||
              (regState === 4 &&
                '体験クーポンをご利用いただけなかったお客様に対して、代わりの賞品をお届けいたします。本日より3日以内に、お届け先のご住所を、ご入力いただきますよう、お願いいたします。')
            }
            size={TextBody.sizes.s}
          />
          <Container pt="4">
            {regState !== 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={getEmailVerificationRoute()}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      getEmailVerificationRoute()
                    )
                  }}>
                  アカウント認証はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
            {regState === 4 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={`/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      `/qoins/products/confirmation?prizeid=${data.prize_id}&callredirectUrl=/profile#notices`
                    )
                  }}>
                  住所登録はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
          </Container>
        </>
      )}
      {expiredDateParsed < newDate && (
        <>
          <TextBody size={TextBody.sizes.s}>
            {regState !== 4 && 'アカウントの認証・住所登録期限が終了しました'}
            {regState === 4 && '住所登録期限が終了しました'}
          </TextBody>
        </>
      )}
    </>
  )
}

const qoinsEarn = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.registration === 1 &&
            data.type !== 1 &&
            `${data.point}ポイントが付与されました`) ||
          (data.registration === 1 &&
            data.type === 1 &&
            `${data.point}ステージポイントが付与されました`) ||
          (data.registration !== 1 && `${data.message}でのポイント獲得に関して`)
        }`}
      />
      {data.registration === 1 && (
        <TextBody
          value={
            (data.type !== 1 &&
              data.gain === 0 &&
              '（ポイント増量適用対象外)') ||
            (data.type !== 1 &&
              `${data.message}で${data.point}ポイントが付与されました`) ||
            (data.type === 1 &&
              `${data.message} で${data.point}ステージポイントが付与されました`)
          }
        />
      )}
      {data.registration === 0 && (
        <TextBody value="ポイント獲得、利用には製品登録が必要です。" />
      )}
      <Container pt="4">
        {data.type !== 1 && (
          <>
            {data.registration === 1 && (
              <TextBody>
                <Link
                  newTab={false}
                  href="/profile#points+history"
                  safe={true}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      '/profile#points+history'
                    )
                  }}>
                  詳しくはこちら
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
            {data.registration === 0 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={getProfileDevicesRoute()}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      getProfileDevicesRoute()
                    )
                  }}>
                  製品登録はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
          </>
        )}
        {data.type === 1 && (
          <>
            {data.registration === 1 && (
              <TextBody>
                <Link
                  newTab={false}
                  href="/profile/"
                  onClickHandler={e => {
                    noticeLinkHandler(e, handleNotice, id, '/profile/')
                  }}>
                  詳しくはこちら
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
            {data.registration === 0 && (
              <TextBody>
                <Link
                  newTab={false}
                  href={getProfileDevicesRoute()}
                  onClickHandler={e => {
                    noticeLinkHandler(
                      e,
                      handleNotice,
                      id,
                      getProfileDevicesRoute()
                    )
                  }}>
                  製品登録はこちらから
                  <Container pl="2" display={Container.displays.inlineBlock}>
                    <Icon
                      image={Icon.images.arrowRight}
                      size={Icon.sizes.xs}></Icon>
                  </Container>
                </Link>
              </TextBody>
            )}
          </>
        )}
      </Container>
    </>
  )
}

const qoinsEarnPromotion = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.registration === 1 &&
            `${data.name}で${data.point}ポイントが付与されました`) ||
          (data.registration === 0 && `${data.name}でのポイント獲得に関して`)
        }`}
      />
      <TextBody
        value={
          (data.registration === 1 &&
            `${data.title}${data.point}ポイントが付与されましたglu`) ||
          (data.registration === 0 &&
            'ポイント獲得、利用には製品登録が必要です。')
        }
        size={TextBody.sizes.s}
      />

      <Container pt="4">
        {data.registration === 1 && (
          <TextBody>
            <Link
              newTab={false}
              href="/profile#points+history"
              safe={true}
              onClickHandler={e => {
                noticeLinkHandler(
                  e,
                  handleNotice,
                  id,
                  '/profile#points+history'
                )
              }}>
              詳しくはこちら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
        {data.registration === 0 && (
          <TextBody>
            <Link
              newTab={false}
              href={getProfileDevicesRoute()}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, getProfileDevicesRoute())
              }}>
              製品登録はこちらから
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const qoinsEarnSurvey = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`
           ${
             (data.registration === 1 &&
               `${data.point}ポイントが付与されました`) ||
             (data.registration === 0 &&
               `${data.message}でのポイント獲得に関して`)
           }
           `}
      />
      <TextBody
        value={
          (data.registration === 1 &&
            `LINEアンケートにご回答ありがとうございました。${data.point}ポイントが付与されました`) ||
          (data.registration === 0 &&
            'ポイント獲得、利用には製品登録が必要です。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        {data.registration === 1 && (
          <TextBody>
            <Link
              newTab={false}
              href="/profile#points+history"
              safe={true}
              onClickHandler={e => {
                noticeLinkHandler(
                  e,
                  handleNotice,
                  id,
                  '/profile#points+history'
                )
              }}>
              詳しくはこちら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
        {data.registration === 0 && (
          <TextBody>
            <Link
              newTab={false}
              href={getProfileDevicesRoute()}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, getProfileDevicesRoute())
              }}>
              製品登録はこちらから
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const qoinsMove = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null
  if (data.point === undefined && data.point !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.registration === 1 &&
            `${data.point}ポイントが付与されました`) ||
          (data.registration === 0 && `${data.message}でのポイント獲得に関して`)
        }`}
      />
      <TextBody
        value={
          (data.registration === 1 &&
            `${data.point}ポイントが付与されました`) ||
          (data.registration === 0 &&
            'ポイント獲得、利用には製品登録が必要です。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        {data.registration === 1 && (
          <TextBody>
            <Link
              newTab={false}
              href="/profile#points+history"
              onClickHandler={e => {
                noticeLinkHandler(
                  e,
                  handleNotice,
                  id,
                  '/profile#points+history'
                )
              }}>
              詳しくはこちら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
        {data.registration === 0 && (
          <TextBody>
            <Link
              newTab={false}
              href={getProfileDevicesRoute()}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, getProfileDevicesRoute())
              }}>
              製品登録はこちらから
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const qoinsEarnPackcode = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice
        date={date}
        name={`${data.qoins}ポイントが付与されました`}
      />
      <TextBody
        value={`パックコード抽選により${data.qoins}ポイントが付与されました`}
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile#points+history"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile#points+history')
            }}>
            詳しくはこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const statusStart = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null
  if (data.registration === undefined && data.registration !== 0) return null
  if (data.cause === undefined && data.cause !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`
               ${
                 (data.status === 3 &&
                   'あなたはプラチナステージでのスタートです') ||
                 (data.status === 2 &&
                   'あなたはゴールドステージでのスタートです') ||
                 (data.status === 1 &&
                   'あなたはシルバーステージでのスタートです') ||
                 (data.status === 0 && '製品登録をお願いします')
               }
             `}
      />
      <TextBody
        value={
          (data.status === 0 &&
            '会員特典プログラムに参加するためには、製品登録が必要です') ||
          (data.status === 1 &&
            '現在のステージで獲得ポイント数が7000ポイントに達するとゴールドステージにランクアップします') ||
          (data.status === 2 &&
            data.cause === 2 &&
            '様々な特典をお楽しみください。') ||
          (data.status === 2 &&
            data.cause === 1 &&
            '様々な特典をお楽しみください。') ||
          (data.status === 3 && '様々な特典をお楽しみください。')
        }
      />
      <Container pt="4">
        {data.status <= 1 && (
          <TextBody>
            <Link
              newTab={false}
              href="/profile/"
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, '/profile/')
              }}>
              詳しくはこちら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
        {data.status > 1 && (
          <TextBody>
            <Link
              newTab={false}
              href={getProfileDevicesRoute()}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, getProfileDevicesRoute())
              }}>
              製品登録はこちらから
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const statusUp = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null
  if (data.cause === undefined && data.cause !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 2 && 'ゴールドステージへのランクアップのお知らせ') ||
          (data.status === 3 && 'プラチナステージへのランクアップのお知らせ')
        }`}
      />

      {data.status === 2 && (
        <TextBody
          value={
            (data.cause === 0 &&
              '現在のステージでの獲得ポイント数が7000ポイントに達したので、ゴールドステージにランクアップしました。おめでとうございます。') ||
            (data.cause === 2 &&
              'IQOS定額プランへの加入で、ゴールドステージにランクアップしました。おめでとうございます。') ||
            (data.cause === 1 &&
              'ゴールドパスの当選で、ゴールドステージにランクアップしました。おめでとうございます。')
          }
          size={TextBody.sizes.s}
        />
      )}
      {data.status === 3 && (
        <Container pt="4">
          <TextBody
            value="現在のステージでの獲得ポイント数が13000ポイントに達したので、翌年度のステージはプラチナステージとなります。おめでとうございます。"
            size={TextBody.sizes.s}
          />
          <Container pt="4">
            <TextBody size={TextBody.sizes.s}>
              <Link
                newTab={false}
                href="/profile/"
                onClickHandler={e => {
                  noticeLinkHandler(e, handleNotice, id, '/profile/')
                }}>
                詳しくはこちら
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          </Container>
        </Container>
      )}
    </>
  )
}

const couponVoucherLoyalty = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバーステージランク会員特典「10％オフクーポン」がご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールドステージランク会員特典「20％オフクーポン」がご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナステージランク会員特典「30％オフクーポン」がご利用いただけます。')
        }`}
      />
      <TextBody
        acceptsHtml
        value={
          (data.status === 1 &&
            'あなたはシルバーステージランクになりました。<br> IQOS製品をご購入いただく際に10%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に１回までご利用いただけます。') ||
          (data.status === 2 &&
            'あなたはゴールドステージランクになりました。<br> IQOS製品をご購入いただく際に20%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に１回までご利用いただけます。') ||
          (data.status === 3 &&
            'あなたはプラチナステージランクになりました。<br> IQOS製品をご購入いただく際に30%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に１回までご利用いただけます。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            詳しくはこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const eventVoucher = ({ data, date }) => {
  return (
    <>
      <HeaderNotice
        date={date}
        name={
          'ゴールド会員特典の「1,500円のアクセサリークーポン」プレゼントのお知らせ'
        }
      />
      <TextBody
        value={`ゴールド会員特典の「1,500円のアクセサリークーポン」を進呈いたしました。IQOSオンラインストアにて、IQOSキャップやドアカバーなどご購入の際ご利用いただけます。（有効期限は本日から90日間です。）お客様のクーポンコードはこちら：
           ${data.code}`}
        size={TextBody.sizes.s}></TextBody>
    </>
  )
}

const voucherDiscount2021 = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバーステージランク会員特典「10%オフクーポン」がご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールドステージランク会員特典「20％オフクーポン」がご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナステージランク会員特典「30％オフクーポン」がご利用いただけます。')
        }`}
      />
      <TextBody
        acceptsHtml
        value={
          (data.status === 1 &&
            'あなたはプラチナステージランクになりました。<br>IQOS ILUMA PRIMEまたはIQOS ILUMAをご購') ||
          (data.status === 2 &&
            'あなたはプラチナステージランクになりました。<br>IQOS ILUMA PRIMEまたはIQOS ILUMAをご購') ||
          (data.status === 3 &&
            'あなたはプラチナステージランクになりました。<br>IQOS ILUMA PRIMEまたはIQOS ILUMAをご購')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getPromotionRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getPromotionRoute())
            }}>
            ※常時開催の割引プログラムを別途実施しています。詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            ※会員特典割引の詳細はこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherGold2021 = ({ date }) => {
  return (
    <>
      <HeaderNotice
        date={date}
        name={
          'ゴールド会員特典の「1,500円のアクセサリークーポン」プレゼントのお知らせ'
        }
      />
      <TextBody
        acceptsHtml
        value="ゴールド会員特典の「1,500円のアクセサリークーポン」を進呈いたしました。<br>IQOSオンラインストアにて、アクセサリーのご購入の際にご利用いただけます。（有効期限は上記記載の日付から90日間です。）"
        size={TextBody.sizes.s}
      />
    </>
  )
}

const voucherPlatinum2021 = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getCatalogueRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getCatalogueRoute())
            }}>
            お手続きはこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherDiscountReplace2021 = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバーステージランク会員特典「10%オフクーポン」がご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールドステージランク会員特典「20%オフクーポン」がご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナステージランク会員特典「30%オフクーポン」がご利用いただけます。')
        }
         `}
      />
      <TextBody
        acceptsHtml
        value={
          (data.status === 1 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはシルバーステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に10%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 2 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはゴールドステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に20%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 3 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはプラチナステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に30%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getPromotionRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getPromotionRoute())
            }}>
            ※常時開催の割引プログラムを別途実施しています。詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            ※会員特典割引の詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherDiscountUpdate2021 = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバーステージランク会員特典「10%オフクーポン」がご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールドステージランク会員特典「20%オフクーポン」がご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナステージランク会員特典「30%オフクーポン」がご利用いただけます。')
        }`}
      />
      <TextBody
        acceptsHtml
        value={
          (data.status === 1 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはシルバーステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に10%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 2 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはゴールドステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に20%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 3 &&
            'IQOS ILUMA PRIME及びIQOS ILUMAを対象とした新しい会員特典割引プログラムが開始しました。<br>あなたはプラチナステージランクになりますので、IQOS ILUMA PRIMEまたは IQOS ILUMAをご購入いただく際に30%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getPromotionRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getPromotionRoute())
            }}>
            ※常時開催の割引プログラムを別途実施しています。詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            ※会員特典割引の詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherGoldUpdate2021 = ({ date }) => {
  return (
    <>
      <HeaderNotice
        date={date}
        name={
          'ゴールド会員特典の「1,500円のアクセサリークーポン」についてのお知らせ'
        }
      />
      <TextBody
        acceptsHtml
        value={
          '本日よりIQOS ILUMA専用アクセサリー購入時にもご利用いただけます。<br>IQOSオンラインストアにて、アクセサリーのご購入の際にご利用いただけます。'
        }
        size={TextBody.sizes.s}
      />
    </>
  )
}

const voucherPlatinumUpdate2021 = ({ date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice
        date={date}
        name={'プラチナ会員特典「最新のIQOS製品進呈」についてのお知らせ'}
      />
      <TextBody
        acceptsHtml
        value={
          'IQOSオンラインストアにてIQOS ILUMA PRIMEまたは IQOS ILUMAをお受け取りになれます。本特典の受け取り期限が変更され、2021年12月31日までとなります。必ず2021年12月31日までにお受け取りのお手続きを完了いただきますようお願いいたします。なお、お手続きは以下の通りです。<br><br>①IQOSオンラインストアにアクセスする<br>②IQOS ILUMA PRIMEまたは IQOS ILUMA製品を選ぶ<br>③製品をカートに入れ、レジに進む<br>④「注文内容を確認する」画面で「IQOS製品進呈ギフトクーポン」の適用を必ず選択する<br>⑤注文を確定する<br><br>※購入と同じ手順ですが、クーポンを使用することで、お支払いは発生いたしません。<br>※注文方法は「クレジットカード払い」もしくは「代金引換」をご選択ください。「後払い」は選択できませんのでご注意ください。<br>※ギフトクーポンを選択しないで注文確定すると、お支払いが発生してしまいます。ご注意ください。<br>※対象製品は、セット製品・限定モデルは除きます。'
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getCatalogueRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getCatalogueRoute())
            }}>
            お手続きはこちら
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherDiscount2022 = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバー会員特典「10%オフクーポン」がご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールド会員特典「20%オフクーポン」がご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナ会員特典「30%オフクーポン」がご利用いただけます。')
        }`}
      />
      <TextBody
        acceptsHtml
        value={
          (data.status === 1 &&
            'あなたはシルバーステージになりました。<br>IQOS ILUMA PRIME、 IQOS ILUMAまたは IQOS ILUMA ONEのキット製品をご購入いただく際に10%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 2 &&
            'あなたはゴールドステージになりました。<br>IQOS ILUMA PRIME、 IQOS ILUMAまたは IQOS ILUMA ONEのキット製品をご購入いただく際に20%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 3 &&
            'あなたはプラチナステージになりました。<br>IQOS ILUMA PRIME、 IQOS ILUMAまたは IQOS ILUMA ONEのキット製品をご購入いただく際に30%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getPromotionRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getPromotionRoute())
            }}>
            ※常時開催の割引プログラムを別途実施しています。詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            ※会員特典割引の詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherDiscountUpdate2022 = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.status === 1 &&
            'シルバー会員特典「10%オフクーポン」がIQOS ILUMA ONEでご利用いただけます。') ||
          (data.status === 2 &&
            'ゴールド会員特典「20%オフクーポン」がIQOS ILUMA ONEでご利用いただけます。') ||
          (data.status === 3 &&
            'プラチナ会員特典「30%オフクーポン」がIQOS ILUMA ONEでご利用いただけます。')
        }`}
      />
      <TextBody
        value={
          (data.status === 1 &&
            'IQOS ILUMA ONEが新たに会員特典割引プログラムの対象となりました。あなたはシルバーステージになりますので、IQOS ILUMA PRIME、IQOS ILUMAまたはIQOS ILUMA ONEのキット製品をご購入いただく際に10%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 2 &&
            'IQOS ILUMA ONEが新たに会員特典割引プログラムの対象となりました。あなたはゴールドステージになりますので、IQOS ILUMA PRIME、IQOS ILUMAまたはIQOS ILUMA ONEのキット製品をご購入いただく際に20%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。') ||
          (data.status === 3 &&
            'IQOS ILUMA ONEが新たに会員特典割引プログラムの対象となりました。あなたはプラチナステージになりますので、IQOS ILUMA PRIME、IQOS ILUMAまたはIQOS ILUMA ONEのキット製品をご購入いただく際に30%オフになるクーポンがご利用いただけます。こちらはステージ有効期間内に1回までご利用いただけます。')
        }
        size={TextBody.sizes.s}
      />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={getPromotionRoute()}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, getPromotionRoute())
            }}>
            ※常時開催の割引プログラムを別途実施しています。詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href="/profile/"
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, '/profile/')
            }}>
            ※会員特典割引の詳細はこちらへ
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const voucherPlatinum2022 = ({ data, date, handleNotice, id }) => {
  return (
    <>
      <HeaderNotice date={date} name={data.title} />
      <TextBody acceptsHtml value={data.comment} size={TextBody.sizes.s} />
      <Container pt="4">
        <TextBody>
          <Link
            newTab={false}
            href={data['uri/web']}
            onClickHandler={e => {
              noticeLinkHandler(e, handleNotice, id, data['uri/web'])
            }}>
            {data.button}
            <Container pl="2" display={Container.displays.inlineBlock}>
              <Icon image={Icon.images.arrowRight} size={Icon.sizes.xs}></Icon>
            </Container>
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const noticeQuest = ({ data, date, handleNotice, id }) => {
  if (data.status === undefined && data.status !== 0) return null

  return (
    <>
      <HeaderNotice date={date} name={'QUEST投稿審査結果'} />
      <TextBody
        value={
          (data.status === 1 &&
            `あなたのクエスト投稿が承認され、${data.point}ポイントが付与されました！`) ||
          (data.status === 2 &&
            'クエストの投稿審査が完了しました。審査結果は下記よりご確認いただけます。') ||
          (data.status === 4 &&
            'クエストの投稿審査が完了しました。審査結果は下記よりご確認いただけます。')
        }
        size={TextBody.sizes.s}
      />

      <Container pt="4">
        {data['uri/web'] && (
          <TextBody>
            <Link
              newTab={false}
              href={data['uri/web']}
              onClickHandler={e => {
                noticeLinkHandler(e, handleNotice, id, data['uri/web'])
              }}>
              詳しくはこちら
              <Container pl="2" display={Container.displays.inlineBlock}>
                <Icon
                  image={Icon.images.arrowRight}
                  size={Icon.sizes.xs}></Icon>
              </Container>
            </Link>
          </TextBody>
        )}
      </Container>
    </>
  )
}

const qoinsEarnQuestLikeR = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.registration === 1 &&
            data.type !== 1 &&
            `${data.point}ポイントが付与されました`) ||
          (data.registration === 1 &&
            data.type === 1 &&
            `${data.point}ステージポイントが付与されました`) ||
          (data.registration === 0 && `${data.message}でのポイント獲得に関して`)
        }`}
      />

      {data.registration === 1 && (
        <TextBody
          value={
            (data.type !== 1 &&
              `第${data.extra && data.extra.group}回QUEST${
                data.extra && data.extra.cursor
              }の投稿にいいね！されました。${data.point}ポイント`) ||
            (data.type === 1 &&
              `第${data.extra && data.extra.group}回QUEST${
                data.extra && data.extra.cursor
              }の投稿にいいね！されました。${data.point}ステージポイント`)
          }
          size={TextBody.sizes.s}
        />
      )}
      {data.registration === 0 && (
        <TextBody
          value={'ポイント獲得、利用には製品登録が必要です。'}
          size={TextBody.sizes.s}
        />
      )}

      {data.type !== 1 && (
        <Container pt="4">
          {data.registration === 1 && (
            <TextBody>
              <Link
                newTab={false}
                href="/profile#points+history"
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    '/profile#points+history'
                  )
                }}>
                詳しくはこちら
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
          {data.registration === 0 && (
            <TextBody>
              <Link
                newTab={false}
                href={getProfileDevicesRoute()}
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    getProfileDevicesRoute()
                  )
                }}>
                製品登録はこちらから
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
        </Container>
      )}
      {data.type === 1 && (
        <Container pt="4">
          {data.registration === 1 && (
            <TextBody>
              <Link
                newTab={false}
                href="/profile/"
                onClickHandler={e => {
                  noticeLinkHandler(e, handleNotice, id, '/profile/')
                }}>
                詳しくはこちら
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
          {data.registration === 0 && (
            <TextBody>
              <Link
                newTab={false}
                href={getProfileDevicesRoute()}
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    getProfileDevicesRoute()
                  )
                }}>
                製品登録はこちらから
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
        </Container>
      )}
    </>
  )
}

const qoinsEarnQuestLikeS = ({ data, date, handleNotice, id }) => {
  if (data.registration === undefined && data.registration !== 0) return null
  if (data.type === undefined && data.type !== 0) return null

  return (
    <>
      <HeaderNotice
        date={date}
        name={`${
          (data.registration === 1 &&
            data.type !== 1 &&
            `${data.point}ポイントが付与されました`) ||
          (data.registration === 1 &&
            data.type === 1 &&
            `${data.point}ステージポイントが付与されました`) ||
          (data.registration === 0 && `${data.message}でのポイント獲得に関して`)
        }`}
      />

      {data.registration === 1 && (
        <TextBody
          value={
            (data.type !== 1 &&
              `第${data.extra && data.extra.group}回QUEST${
                data.extra && data.extra.cursor
              }の投稿にいいね！されました。${data.point}ポイント`) ||
            (data.type === 1 &&
              `第${data.extra && data.extra.group}回QUEST${
                data.extra && data.extra.cursor
              }の投稿にいいね！されました。${data.point}ステージポイント`)
          }
          size={TextBody.sizes.s}
        />
      )}
      {data.registration === 0 && (
        <TextBody
          value="ポイント獲得、利用には製品登録が必要です。"
          size={TextBody.sizes.s}></TextBody>
      )}

      {data.type !== 1 && (
        <Container pt="4">
          {data.registration === 1 && (
            <TextBody>
              <Link
                newTab={false}
                href="/profile#points+history"
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    '/profile#points+history'
                  )
                }}>
                詳しくはこちら
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
          {data.registration === 0 && (
            <TextBody>
              <Link
                newTab={false}
                href={getProfileDevicesRoute()}
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    getProfileDevicesRoute()
                  )
                }}>
                製品登録はこちらから
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
        </Container>
      )}
      {data.type === 1 && (
        <Container pt="4">
          {data.registration === 1 && (
            <TextBody>
              <Link
                newTab={false}
                href="/profile/"
                onClickHandler={e => {
                  noticeLinkHandler(e, handleNotice, id, '/profile/')
                }}>
                詳しくはこちら
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
          {data.registration === 0 && (
            <TextBody>
              <Link
                newTab={false}
                href={getProfileDevicesRoute()}
                onClickHandler={e => {
                  noticeLinkHandler(
                    e,
                    handleNotice,
                    id,
                    getProfileDevicesRoute()
                  )
                }}>
                製品登録はこちらから
                <Container pl="2" display={Container.displays.inlineBlock}>
                  <Icon
                    image={Icon.images.arrowRight}
                    size={Icon.sizes.xs}></Icon>
                </Container>
              </Link>
            </TextBody>
          )}
        </Container>
      )}
    </>
  )
}

const noticeTemplateIds = {
  'notice/comment': noticeCommentTemplate,
  'notice/uri': noticeUriTemplate,
  'notice/uri/2': noticeUriTemplateTwo,
  'notice/uri/duo': noticeUriTemplateDuo,
  'regstate/status/0': regstateStatusZero,
  'prize/winning': prizeWinning,
  'prize/winning/digital': prizeWinningDigital,
  'prize/toropical/winning': prizeToropicalWinning,
  'prize/winning/cherish': prizeWinningCherish,
  'qoins/earn': qoinsEarn,
  'qoins/earn/promotion': qoinsEarnPromotion,
  'qoins/earn/survey': qoinsEarnSurvey,
  'qoins/move': qoinsMove,
  'qoins/earn/packcode': qoinsEarnPackcode,
  'status/start': statusStart,
  'status/up': statusUp,
  'coupon/voucher/loyalty': couponVoucherLoyalty,
  'event/voucher/201911': eventVoucher,
  'voucher/discount/2021': voucherDiscount2021,
  'voucher/gold/2021': voucherGold2021,
  'voucher/platinum/2021': voucherPlatinum2021,
  'voucher/discount/replace/2021': voucherDiscountReplace2021,
  'voucher/discount/update/2021': voucherDiscountUpdate2021,
  'voucher/gold/update/2021': voucherGoldUpdate2021,
  'voucher/platinum/update/2021': voucherPlatinumUpdate2021,
  'voucher/discount/2022': voucherDiscount2022,
  'voucher/discount/update/2022': voucherDiscountUpdate2022,
  'voucher/platinum/2022': voucherPlatinum2022,
  'notice/quest': noticeQuest,
  'notice/quest/tx': noticeQuest,
  'qoins/earn/quest/like/r': qoinsEarnQuestLikeR,
  'qoins/earn/quest/like/s': qoinsEarnQuestLikeS
}

export default NoticeTemplateHelper
